import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { WaitingTime } from '@classes/waiting-time';

@Injectable({
  providedIn: 'root'
})
export class WaitingTimesService {
  waitingTimesListChanged = new Subject<WaitingTime[]>();
  private baseUrl: string = environment.apiUrl + 'waiting-times';
  private waitingTimes: WaitingTime[];

  constructor(
    private http: HttpClient
  ) { }

  get(): Observable<WaitingTime[]> {
    return this.http.get<WaitingTime[]>(this.baseUrl)
      .pipe(
        map(waitingTimes => {
          this.waitingTimes = waitingTimes.map(c => WaitingTime.fromObject(c));
          this.waitingTimesListChanged.next([...this.waitingTimes]);
          return [...this.waitingTimes];
        })
      );
  }

  put(waitingTime: WaitingTime): Observable<WaitingTime> {
    return this.http.put<WaitingTime>(this.baseUrl, waitingTime)
      .pipe(
        tap(editedWaitingTime => {
          editedWaitingTime = WaitingTime.fromObject(editedWaitingTime);
          this.waitingTimes = this.waitingTimes.map(c => c.id === editedWaitingTime.id ? editedWaitingTime : c);
          this.waitingTimesListChanged.next([...this.waitingTimes]);
        })
      );
  }

  post(waitingTime: WaitingTime): Observable<WaitingTime> {
    return this.http.post<WaitingTime>(this.baseUrl, waitingTime)
      .pipe(
        tap(createdWaitingTime => {
          createdWaitingTime = WaitingTime.fromObject(createdWaitingTime);
          this.waitingTimes.push(createdWaitingTime);
          this.waitingTimesListChanged.next([...this.waitingTimes]);
        })
      );
  }
}
